import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faUserGraduate, faUserTie, faWindowRestore, faList } from "@fortawesome/free-solid-svg-icons";
import { CustomSidebar } from "./Custom-Sidebar";
import LottieIcon from "../LottieIcon/LottieIcon";
import { useLocation } from "react-router-dom";
import PersonalInfoIcon from "../../Images/icons/components/personalinfo-icon";
import EducationIcon from "../../Images/icons/components/education-icon";
import ProfessionalExperieceIcon from "../../Images/icons/components/professionalExp-icon";
import SkillsIcon from "../../Images/icons/components/skills-icon";
import ProfessionalSummaryIcon from "../../Images/icons/components/professionalSummary-icon";

const ResumeSidebar = ({ title }) => {
  const location = useLocation();
  const isActiveLink = (link) => location.pathname.includes(link.split("?")[0]);

  const profileId = localStorage.getItem("profileId");
   const menuItems = [
    {
      id: 1,
      label: "Personal Information",
      link: `/personalInfo/?profileId=${profileId}`,
      lottieIcon: "personalInfo",
      staticIcon: <PersonalInfoIcon color="#000000" />,
      activeIcon: <PersonalInfoIcon color="#FFFFFF" />,
    },
    {
      id: 2,
      label: "Education",
      link: `/education/?profileId=${profileId}`,
      lottieIcon: "educationIcon",
      staticIcon: <EducationIcon color="#000000" />,
      activeIcon: <EducationIcon color="#FFFFFF" />,
    },
    {
      id: 3,
      label: "Professional Experience",
      link: `/professionalExperience/?profileId=${profileId}`,
      lottieIcon: "professionalExp",
      staticIcon: <ProfessionalExperieceIcon color="#000000" />,
      activeIcon: <ProfessionalExperieceIcon color="#FFFFFF" />,
    },
    {
      id: 4,
      label: "Skills",
      link: `/skills/?profileId=${profileId}`,
      lottieIcon: "idea",
      staticIcon: <SkillsIcon color="#000000" />,
      activeIcon: <SkillsIcon color="#FFFFFF"/>,
    },
    {
      id: 5,
      label: "Professional Summary",
      link: `/professionalSummary/?profileId=${profileId}`,
      lottieIcon: "professionalSummary",
      staticIcon: <ProfessionalSummaryIcon color="#000000" />,
      activeIcon: <ProfessionalSummaryIcon color="#FFFFFF" />,
    },
  ];
  return (
    <div>
      <CustomSidebar title={title} menuItems={menuItems} width="100%" />
    </div>
  );
};

export default ResumeSidebar;
